module.exports = __webpack_public_path__ + "static/media/grin-beam-sweat.c649c4e1.svg";